import SectionHeading from '@/pages/home/components/SectionHeading';
import { trustPoints } from '@/mocks/home';

export default function TrustSection() {
  return (
    <section id="trust" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8 xl:px-10">
        <SectionHeading
          eyebrow="Trust"
          title="我们如何整理与核实信源"
          desc="黑料档案最怕的是断章取义。所以每一条内容都尽量做三件事：挂上来源、并列多方说法、把改动记录留下来。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {trustPoints.map((point) => (
            <div
              key={point.title}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${point.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {point.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-4 rounded-lg border border-primary-200 bg-primary-50 p-5 md:flex-row md:items-center md:justify-between md:p-6">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-error-warning-line text-xl" />
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-950">
                发现档案内容有误？
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                提交相关材料后我们会优先复核，确认有误的条目会标注更正说明并保留修改留痕，而不是直接静默删除。
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-3">
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              提交更正申请
            </button>
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看归档规范
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}